import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom'
import customerActions from "../../../Actions/customerActions";
import employeesActions from '../../../Actions/Von/employeesActions';

const VonEmployeesContainer = () => {
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const vonAccounts = useSelector((state) => state.CustomerReducer.vonAccounts);
    const vonProducts = useSelector((state) => state.CustomerReducer.vonProducts);
    const vonEmployeeTypeRestrictions = useSelector((state) => state.CustomerReducer.vonEmployeeTypeRestrictions);
    const vonProductsLoading = useSelector((state) => state.CommonReducer.dataLoading.vonProducts);
    const vonAccountsLoading = useSelector((state) => state.CommonReducer.dataLoading.vonAccounts);
    const dispatch = useDispatch();

    const customerId = customer.vonCustomer?.id ?? customer.vossCustomer.id;

    useEffect(() => {
        if (customer.vonCustomer || customer.vossCustomer && !vonAccountsLoading && !vonAccounts) {
            dispatch(customerActions.getVonAccounts(customerId));
        }

        if (customer.vonCustomer || customer.vossCustomer && !vonProducts && !vonProductsLoading) {
            dispatch(customerActions.getCustomerVonProducts(customerId));
        }

        if (!vonEmployeeTypeRestrictions) {
            dispatch(employeesActions.getEmployeeTypeRestrictions());
        }
    }, []);

    if (!vonAccounts || !vonProducts) {
        return null;
    }

    return <Outlet />
}

export default VonEmployeesContainer;